<template>
    <div class="profile-image">
        <template v-if="isPilulkaEmployee">
            <img src="/nuxt-assets/images/discussions/symbol-gradient.png" width="53" height="53" />
        </template>
        <div v-else class="position-relative">
            <div>
                <img src="/nuxt-assets/images/discussions/profile_image_placeholder.svg" />
            </div>
            <img v-if="hasShield" class="shield" src="/nuxt-assets/images/discussions/bronze_shield.svg" alt="shield" />
        </div>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        isPilulkaEmployee: {
            type: Boolean,
            required: false,
            default: false,
        },
        hasShield: {
            type: Boolean,
            default: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.profile-image {
    min-width: 50px;

    .shield {
        position: absolute;
        bottom: 0;
        right: 0;
    }
}
</style>
